import { render, staticRenderFns } from "./dual-track-warning.vue?vue&type=template&id=56c49dfc&scoped=true"
import script from "./dual-track-warning.vue?vue&type=script&lang=js"
export * from "./dual-track-warning.vue?vue&type=script&lang=js"
import style0 from "./dual-track-warning.vue?vue&type=style&index=0&id=56c49dfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c49dfc",
  null
  
)

export default component.exports